import { FC } from 'react'

import { ISvgClass } from '../interface'

const WifiLockedIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19 22C18.7167 22 18.4793 21.904 18.288 21.712C18.096 21.5207 18 21.2833 18 21V18C18 17.7167 18.096 17.4793 18.288 17.288C18.4793 17.096 18.7167 17 19 17V16C19 15.45 19.1957 14.979 19.587 14.587C19.979 14.1957 20.45 14 21 14C21.55 14 22.021 14.1957 22.413 14.587C22.8043 14.979 23 15.45 23 16V17C23.2833 17 23.5207 17.096 23.712 17.288C23.904 17.4793 24 17.7167 24 18V21C24 21.2833 23.904 21.5207 23.712 21.712C23.5207 21.904 23.2833 22 23 22H19ZM20 17H22V16C22 15.7167 21.904 15.4793 21.712 15.288C21.5207 15.096 21.2833 15 21 15C20.7167 15 20.4793 15.096 20.288 15.288C20.096 15.4793 20 15.7167 20 16V17ZM6.35 13.35L4.25 11.2C5.23333 10.2167 6.38767 9.43767 7.713 8.863C9.03767 8.28767 10.4667 8 12 8C13.5333 8 14.9627 8.29167 16.288 8.875C17.6127 9.45833 18.7667 10.25 19.75 11.25L17.65 13.35C16.9167 12.6167 16.0667 12.0417 15.1 11.625C14.1333 11.2083 13.1 11 12 11C10.9 11 9.86667 11.2083 8.9 11.625C7.93333 12.0417 7.08333 12.6167 6.35 13.35ZM2.1 9.1L0 7C1.53333 5.43333 3.325 4.20833 5.375 3.325C7.425 2.44167 9.63333 2 12 2C14.3667 2 16.575 2.44167 18.625 3.325C20.675 4.20833 22.4667 5.43333 24 7L21.9 9.1C20.6167 7.81667 19.1293 6.81233 17.438 6.087C15.746 5.36233 13.9333 5 12 5C10.0667 5 8.254 5.36233 6.562 6.087C4.87067 6.81233 3.38333 7.81667 2.1 9.1ZM12 19L15.525 15.45C15.075 15 14.55 14.6457 13.95 14.387C13.35 14.129 12.7 14 12 14C11.3 14 10.65 14.129 10.05 14.387C9.45 14.6457 8.925 15 8.475 15.45L12 19Z"
        fill="inherit"
      />
    </svg>
  )
}

export default WifiLockedIcon
